module.exports = __webpack_public_path__ + "static/img/gaozhongdili5.0252fc05.jpg";